import { PageLocatorMap } from '../types/PageLocatorMap';

export const activationPage = {
  alert: {
    deliverPinError: 'activation-page.alert.deliver-pin-error',
    parameterError: 'activation-page.alert.parameter-error',
    signInLink: 'activation-page.alert.signin-link',
    signUpLink: 'activation-page.alert.signup-link',
  },
  footer: {
    root: 'activation-page.footer.root',
  },
  form: {
    h1: 'activation-page.form.heading1',
    h2: 'activation-page.form.heading2',
    phoneInput: 'activation-page.form.phone-input',
    phoneInputError: 'activation-page.form.phone-error',
    privacyLink: 'activation-page.form.privacy-link',
    root: 'activation-page.form.root',
    submitButton: 'activation-page.form.submit-button',
    termsCheckbox: 'activation-page.form.terms-checkbox',
    termsCheckboxError: 'activation-page.form.terms-error',
    termsLink: 'activation-page.form.terms-link',
  },
  header: {
    root: 'activation-page.header.root',
  },
} as const satisfies PageLocatorMap;
